// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"shared-components-ProductRecommendations-ProductRecommendations__carouselContainer--3YXEc"};